import { ADD_TOKEN, CLEAR_TOKEN } from './tokenTypes';

const initialState = {
    token: null,
    loading: false
};

export default function tokenReducer(state = initialState, action) {
    switch (action.type) {
        case ADD_TOKEN:
            return { ...state, token: action.payload };
        case CLEAR_TOKEN:
            return initialState;
        default:
            return state;
    }
}
